import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { CurrencyDisplay, CurrencyInput, KgDisplay, KgInput } from "../../../Utils/Inputs";

export default function LatexTableRow(props) {
    const { rowName, rowIndex, month, monthIndex, isFirstTable } = props;

    const { control } = useFormContext();

    const kgSecos = useWatch({
        control,
        name: `ComparativoCostoMP.LatexData.${rowName}.${month}.KgSecos`,
    });
    const costoKgSec = useWatch({
        control,
        name: `ComparativoCostoMP.LatexData.${rowName}.${month}.CostoKgSec`,
    });
    const total = (kgSecos * costoKgSec).toFixed(2);

    // CASOS ESPECIALES
    // INVENTARIO INICIAL PARA MESES POSTERIORES A ENERO
    if (!isFirstTable && rowName === 'InventarioInicial') {
        return (
            <tr key={rowIndex}>
                <td><KgDisplay value={kgSecos} /></td>
                <td><CurrencyDisplay value={costoKgSec} decimalScale={5} /></td>
                <td><CurrencyDisplay value={total} /></td>
            </tr>
        )
    }

    return (
        <tr key={rowIndex}>
            <td>
                <KgInput
                    control={control}
                    name={`ComparativoCostoMP.LatexData.${rowName}.${month}.KgSecos`} />
            </td>
            <td>
                <CurrencyInput
                    control={control}
                    name={`ComparativoCostoMP.LatexData.${rowName}.${month}.CostoKgSec`}
                    decimalScale={5} />
            </td>
            <td><CurrencyDisplay value={total} /></td>
        </tr>
    );
}
